var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUrlaubIcon = function SvgUrlaubIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Urlaub Icon")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Urlaub-Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(16.000000, 15.000000)",
    stroke: "#263238",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.998,31.9998 L4.002,31.9998 C1.791,31.9998 0,30.2088 0,27.9978 L0,10.0018 C0,7.7918 1.791,5.9998 4.002,5.9998 L27.998,5.9998 C30.208,5.9998 32,7.7918 32,10.0018 L32,27.9978 C32,30.2088 30.208,31.9998 27.998,31.9998 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 5.9998,
    x2: 7,
    y2: 31.7938,
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.0024,
    y1: 6.2064,
    x2: 25.0024,
    y2: 31.9994,
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8457,-0.0002 L10.8487,-0.0002 C9.7437,-0.0002 8.8477,0.8958 8.8477,2.0018 L8.8477,5.9998 L22.8477,5.9998 L22.8477,2.0018 C22.8477,0.8958 21.9507,-0.0002 20.8457,-0.0002 Z",
    id: "Stroke-7",
    strokeLinejoin: "round"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUrlaubIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/urlaub-icon.578e65f4.svg";
export { ForwardRef as ReactComponent };